import React, { useState } from 'react';
import { GoogleMap, useJsApiLoader, OverlayViewF, InfoWindowF } from '@react-google-maps/api';

const containerStyle = {
    width: '100%',
    height: '400px',
    borderRadius: '15px'
};
////

const defaultCenter = {
    lat: 40.7128,
    lng: -74.0060
};

const libraries = ['places'];

const DomeMap = ({ domes }) => {
    console.log('api_key', process.env.REACT_APP_GOOGLE_MAPS_API_KEY);
    const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

    // Debug: Log API key status (remove in production)
    React.useEffect(() => {
        if (!apiKey) {
            console.error('REACT_APP_GOOGLE_MAPS_API_KEY is not set. Please check your .env file.');
        } else {
            console.log('Google Maps API Key loaded:', apiKey.substring(0, 10) + '...');
        }
    }, [apiKey]);

    const { isLoaded, loadError } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: apiKey || '',
        libraries: libraries
    });

    const [selectedDome, setSelectedDome] = useState(null);

    const [map, setMap] = React.useState(null);

    const onLoad = React.useCallback(function callback(map) {
        setMap(map);
    }, []);

    React.useEffect(() => {
        if (map && domes && domes.length > 0) {
            const bounds = new window.google.maps.LatLngBounds();
            let hasValidCoords = false;
            domes.forEach(dome => {
                if (dome.coordinates && dome.coordinates.lat && dome.coordinates.lng) {
                    bounds.extend({ lat: dome.coordinates.lat, lng: dome.coordinates.lng });
                    hasValidCoords = true;
                }
            });
            if (hasValidCoords) {
                map.fitBounds(bounds);
            }
        }
    }, [map, domes]);
    console.log("domes", domes)
    const onUnmount = React.useCallback(function callback(map) {
        setMap(null);
    }, []);

    if (loadError) {
        return (
            <div style={{ padding: '20px', textAlign: 'center', color: 'red' }}>
                <h5>Error loading Google Maps</h5>
                <p>{loadError.message}</p>
                <p style={{ fontSize: '12px', marginTop: '10px' }}>
                    Please check:
                    <br />1. REACT_APP_GOOGLE_MAPS_API_KEY is set in .env file
                    <br />2. API key has Maps JavaScript API enabled
                    <br />3. API key restrictions allow your domain
                    <br />4. Billing is enabled on Google Cloud project
                </p>
            </div>
        );
    }

    if (!isLoaded) return <div>Loading Map...</div>;

    if (!process.env.REACT_APP_GOOGLE_MAPS_API_KEY) {
        return (
            <div style={{ padding: '20px', textAlign: 'center', color: 'orange' }}>
                <h5>Google Maps API Key Missing</h5>
                <p>Please set REACT_APP_GOOGLE_MAPS_API_KEY in your .env file</p>
            </div>
        );
    }

    return (
        <GoogleMap
            mapContainerStyle={containerStyle}
            center={defaultCenter}
            zoom={10}
            onLoad={onLoad}
            onUnmount={onUnmount}
        >
            {domes && domes.map(dome => {
                const lat = Number(dome.coordinates?.lat);
                const lng = Number(dome.coordinates?.lng);

                return (
                    <OverlayViewF
                        key={dome._id}
                        position={{ lat, lng }}
                        mapPaneName={'overlayMouseTarget'}
                    >
                        <div
                            style={{
                                position: 'absolute',
                                transform: 'translate(-50%, -50%)',
                                cursor: 'pointer',
                                zIndex: 1
                            }}
                            onClick={() => setSelectedDome(dome)}
                        >
                            <div style={{
                                width: '40px',
                                height: '40px',
                                borderRadius: '50%',
                                overflow: 'hidden',
                                border: '2px solid white',
                                boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
                                backgroundColor: '#fff',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                <img
                                    src={dome.coverImage || 'https://via.placeholder.com/40'}
                                    alt={dome.domeName}
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover'
                                    }}
                                    onError={(e) => { e.target.onerror = null; e.target.src = 'https://via.placeholder.com/40?text=D'; }}
                                />
                            </div>
                        </div>
                    </OverlayViewF>
                );
            })}

            {selectedDome && (
                <InfoWindowF
                    position={{
                        lat: Number(selectedDome.coordinates.lat),
                        lng: Number(selectedDome.coordinates.lng)
                    }}
                    onCloseClick={() => setSelectedDome(null)}
                    options={{ zIndex: 9999, maxWidth: 320 }}
                >
                    <div style={{ color: 'black', width: '280px' }}>
                        <h6 style={{ marginBottom: '5px', fontSize: '14px', fontWeight: 'bold' }}>{selectedDome.domeName}</h6>
                        <p style={{ margin: 0, fontSize: '12px', lineHeight: '1.4', marginBottom: '8px' }}>{selectedDome.location}</p>
                        {selectedDome.coverImage && (
                            <img
                                src={selectedDome.coverImage}
                                alt={selectedDome.domeName}
                                style={{
                                    width: '100%',
                                    height: '140px',
                                    marginTop: '5px',
                                    borderRadius: '8px',
                                    objectFit: 'cover',
                                    display: 'block'
                                }}
                            />
                        )}
                    </div>
                </InfoWindowF>
            )}
        </GoogleMap>
    );
};

export default React.memo(DomeMap);
